import { FC } from "react";
import { ContainerProps } from "./types";

export const EmptyContainer = () => {
  return <></>;
};

const Container = <T extends string | number | symbol, D extends {}>({
  type,
  data,
  match,
}: ContainerProps<T, D>) => {
  let Component: FC<D> = EmptyContainer;
  for (let key in match) {
    if (String(type) === String(key)) {
      Component = match[key];
      break;
    }
  }
  return <Component {...data} />;
};

export default Container;
